module.exports = __webpack_public_path__ + "static/media/xvg-color.9ac05adc.png";